import { Capacitor } from './capacitorShim';

/**
 * Platform detection utilities for Capacitor apps.
 * Provides methods to detect the current runtime platform.
 */
export const Platform = {
	/**
	 * Returns true if running as a native app (iOS or Android)
	 */
	isNative: (): boolean => Capacitor.isNativePlatform(),

	/**
	 * Returns true if running on iOS
	 */
	isIOS: (): boolean => Capacitor.getPlatform() === 'ios',

	/**
	 * Returns true if running on Android
	 */
	isAndroid: (): boolean => Capacitor.getPlatform() === 'android',

	/**
	 * Returns true if running in a web browser
	 */
	isWeb: (): boolean => Capacitor.getPlatform() === 'web',

	/**
	 * Returns the current platform name: 'ios', 'android', or 'web'
	 */
	getPlatform: (): string => Capacitor.getPlatform(),
};
